module.exports = __webpack_public_path__ + "files/ad51e4f175a6c9f6bc9a69ba322e94b5.svg";